import styles from './Layout.module.scss'
import { Outlet } from 'react-router-dom'
import { NavBar } from './NavBar/NavBar'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export function Layout() {
    return (
        <div className={styles['wrapper']}>
            <div className={styles['layout']}>
                <NavBar />
            </div>
            <Outlet />
            <ToastContainer style={{ minWidth: "360px"}} />
        </div>
    );
}

